import { useState, useEffect } from 'react';

export const useWindowSize = () => {
   const [size, setSize] = useState(window.innerWidth);

   useEffect(() => {
      const checkSize = () => {
        setSize(window.innerWidth)
      };
      window.addEventListener('resize', checkSize);
      checkSize();

      return () => {
         window.removeEventListener('resize', checkSize);
      };
   }, []);

   return size;
};


